module.exports = __webpack_public_path__ + "assets/img/mr5.e1de9933.png";